import { SelectBox } from 'devextreme-react';
import React, { Component } from 'react';
import { PAYMENT_STATUS } from '../../constants/Config';
import i18n from '../../i18n';
import PropTypes from 'prop-types';

class ServiceNoteStatusSelectBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: {}
        };

        this.onDataChanged = this.onDataChanged.bind(this);
    }

    componentDidMount() {
        this.handleLanguage();
    }

    handleLanguage = () => {
        const { languages } = this.props;

        let datas = [];

        languages.forEach(element => {
            const newArray = [];

            for (const item of PAYMENT_STATUS) {
                const i = Object.assign({}, item);
                const nameParse = (i.name ? JSON.parse(i.name) : '');

                i.name = nameParse[element.languageId];
                newArray.push(i);
            }

            datas = { ...datas, [element.languageId]: newArray };
        });

        this.setState({
            datas
        });
    }

    /**
     * Handle Data Change.
     *
     * @inheritdoc
     */
    onDataChanged(e) {
        const { field } = this.props;

        this.props.updateData({
            [field]: e.value
        });
        if (e.value === null) {
            const { field } = this.props;

            this.props.updateData({
                [field]: null
            });
        }
    }

    render() {
        const { currentLanguageActive, value, i18nLabel } = this.props;
        const { datas } = this.state;

        return (
            <div className="form-group cm-mgr-5">
                <div className={'dx-field'}>
                    <SelectBox
                        searchEnabled={true}
                        items={datas[currentLanguageActive]}
                        value={value}
                        showClearButton={true}
                        valueExpr={'id'}
                        displayExpr={'name'}
                        placeholder={i18n.t(i18nLabel)}
                        onValueChanged={this.onDataChanged}
                    />
                </div>
            </div>
        );
    }
}

ServiceNoteStatusSelectBox.propTypes = {
    currentLanguageActive: PropTypes.string,
    value: PropTypes.string,
    i18nLabel: PropTypes.string,
    languages: PropTypes.array,
    field: PropTypes.string,
    updateData: PropTypes.func
};

export default ServiceNoteStatusSelectBox;
